import { Suspense } from 'react'
import { Loading } from '@targetLoading'

const Loadable = (Component) => (props) => (
  <Suspense fallback={<Loading />}>
    <Component {...props} />
  </Suspense>
)

export default Loadable
